import { baseColors, basePadding } from "@Constants/baseStyles"
import { arrayOfColors } from "@Constants/constant"
import { randomColor } from "@Utils/utils"
import { StyleSheet } from "react-native"
import { RFValue } from "react-native-responsive-fontsize"

const styles = StyleSheet.create({
    contentContainer: { paddingVertical: basePadding.paddingVertical, paddingBottom: 100 },
    loading: {
        flex: 1,
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center"
    }
})

export default styles
